import type { SelectOption } from "@/interface/ShareWindow/PermissionSelect/PermissionSelect";
import { BoardAccessEnum, getBoardAccessEnumToText } from "@/interface/ShareWindow/types";

export const getBoardOptions = (onlyRead: boolean): SelectOption<BoardAccessEnum>[] => {
    const boardAccessEnumToText = getBoardAccessEnumToText();
    const baseOptions: SelectOption<BoardAccessEnum>[] = [
        {
            value: BoardAccessEnum.edit,
            label: boardAccessEnumToText[BoardAccessEnum.edit],
        },
        {
            value: BoardAccessEnum.view,
            label: boardAccessEnumToText[BoardAccessEnum.view],
        },
        {
            value: BoardAccessEnum.viewCopy,
            label: boardAccessEnumToText[BoardAccessEnum.viewCopy],
        },
        {
            value: BoardAccessEnum.denied,
            label: boardAccessEnumToText[BoardAccessEnum.denied],
        },
    ];

    if (!onlyRead) return baseOptions;

    const onlyReadAccess: BoardAccessEnum[] = [BoardAccessEnum.view, BoardAccessEnum.denied];

    return baseOptions.filter((option) => onlyReadAccess.includes(option.value));
};
